export function formatStringToNumber(input: string | number): number | null {
  if (!input) return null;

  if (typeof input === 'number') return input;

  if (!input || !input?.trim()) return null;

  const number = parseFloat(input);

  if (isNaN(number)) return null;

  return number;
}

export function formatSnakeToCamelCaseLabel(input: string): string {
  if (!input) return '';

  return input
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function formatPercent(input: number | string | null | undefined, fractionDigits: number = 2): string {
  const value = typeof input === 'string' ? parseFloat(input) : input;

  if (typeof value !== 'number' || isNaN(value)) {
    return '-';
  }

  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value);
}

export const normalizeSearchText = (text: string) => {
  return text.toLowerCase().trim();
};

export const matchesSearch = (text: string, searchQuery: string) => {
  if (!searchQuery) return true;
  return normalizeSearchText(text).includes(normalizeSearchText(searchQuery));
};

export const generatePersonaFullName = (
  input: Partial<Record<'firstName' | 'lastName', string | null | undefined>> | null
) => {
  return [input?.firstName, input?.lastName].filter(Boolean).join(' ');
};

export const getPersonaInitials = (firstName?: string, lastName?: string): string => {
  return [firstName?.charAt(0), lastName?.charAt(0)].filter(Boolean).join('').toUpperCase();
};

export function camelCaseToNormal(str: string): string {
  return str
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, char => char.toUpperCase())
    .trim();
}

export const getVendorContactRoleName = (role: string) => {
  const roleMap: Record<string, string> = {
    admin: 'Admin',
    support: 'Support',
    sales_rep: 'Sales Rep',
    sales_mgr: 'Sales Manager',
    credit_mgr: 'Credit Manager',
  };

  return roleMap[role] || role;
};

export const getVendorOrLenderContactRoleName = (role: string) => {
  const allRoleMap: Record<string, string> = {
    admin: 'Admin',
    support: 'Support',
    sales_rep: 'Sales Rep',
    sales_mgr: 'Sales Manager',
    credit_mgr: 'Credit Manager',

    executive: 'Executive',
    support_person: 'Support Person',
  };

  return allRoleMap[role] || role;
};
